<template>
  <v-text
    v-if="fontLoaded && status"
    :config="{ ...configText, offset, verticalAlign: 'middle', ...gradient }"
    ref="txtRef"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { get, debounce, max, min } from 'lodash'
import { getTextOffset, loadFont, markTextLayerCreated } from '@/helper/helper'

export default {
  name: 'text-layer',
  props: {
    layer: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    artworkID: {
      type: String,
      required: true
    },
    scale: {
      type: Number,
      default() {
        return 1
      }
    }
  },

  data() {
    return {
      fontSize: this.layer.fontSize,
      fontUrl: null,
      fontLoaded: false,
      offset: { x: 0, y: 0 },
      status: false
    }
  },

  mounted() {
    const interval = setInterval(() => {
      if (this.$refs.txtRef) {
        clearInterval(interval)
        this.$refs.txtRef
          .getNode()
          .on('textChange', debounce(this.onTextChange, 100))
        this.$refs.txtRef.getNode().on('fontSizeChange', ({ newVal }) => {
          this.fontSize = newVal
        })
        this.onTextChange({ newVal: this.configText.text })
      }
    }, 100)
    const { layer } = this
    // Mọi lớp chữ đều chờ font (dùng chung promise nếu cùng font), rồi vẽ lại
    // để chữ hiển thị đúng font vừa tải.
    loadFont(layer.fontFamily)
      .catch(() => false)
      .then(() => {
        this.fontLoaded = true
        this.$nextTick(() => {
          const node = this.$refs.txtRef && this.$refs.txtRef.getNode()
          const konvaLayer = node && node.getLayer()
          if (konvaLayer) konvaLayer.batchDraw()
        })
      })
  },

  watch: {
    fontLoaded() {
      this.checkOffset()
    },
    fontSize() {
      this.checkOffset()
    }
  },
  created() {
    // Báo cho prepareCanvasForCapture biết lớp chữ này hiện sau ~1s.
    markTextLayerCreated()
    const OnThis = this;
    setTimeout(function(){
      OnThis.status = true
    }, 1000)
  },
  computed: {
    ...mapGetters(['personalized', 'artworks']),
    artwork() {
      const { artworks, artworkID } = this
      return artworks.find(art => art.id === artworkID)
    },
    configText() {
      const { layer, artworkID, scale } = this
      const data = get(this.personalized, artworkID, {})
      var config = {}
      if (typeof data[layer.id] !== 'undefined') {
        config = {
          ...layer,
          ...layer.values[0],
          text: data[layer.id]
        }
      } else {
        config = {
          ...layer,
          ...layer.values[0]
        }
      }
      if (layer.hidden && layer.dependOnLayer) {
        config.text = get(
          this.personalized,
          `${artworkID}.${layer.dependOnLayer}`
        )
      } else {
        config.text = get(
          this.personalized,
          `${artworkID}.${layer.id}`,
          layer.values[0].text
        )
      }
      var scaleProps = [
        'x',
        'y',
        'width',
        'height',
        'fontSize',
        'offsetX',
        'offsetY',
        'letterSpacing',
        'strokeWidth',
        'shadowBlur',
        'shadowOffsetX',
        'shadowOffsetY'
      ]
      scaleProps.forEach(key => {
        if (config[key]) {
          config[key] = config[key] * scale
        }
      })
      if (!config.lineHeight) {
        config.lineHeight = 1
      }
      // config.wrap = 'none'
      config.text = this.textTransform(config.text)
      return config
    },
    gradient() {
      const {
        gradientMode,
        fillPriority,
        fillLinearGradientColorStops,
        width,
        height
      } = this.layer
      if (fillPriority === 'linear-gradient') {
        if (gradientMode === 'vertical') {
          return {
            fillLinearGradientStartPointX: width / 2,
            fillLinearGradientStartPointY: 0,
            fillLinearGradientEndPointX: width / 2,
            fillLinearGradientEndPointY: height,
            fillLinearGradientColorStops
          }
        } else {
          return {
            fillLinearGradientStartPointX: 0,
            fillLinearGradientStartPointY: height / 2,
            fillLinearGradientEndPointX: width,
            fillLinearGradientEndPointY: height / 2,
            fillLinearGradientColorStops
          }
        }
      }
      return { fillPriority: 'color' }
    }
  },

  methods: {
    onTextChange({ newVal }) {
      const { layer } = this
      const node = this.$refs.txtRef.getNode()
      if (layer.autofit) {
        var txts = newVal.split('\n')
        if (txts.join('') === '') {
          return
        }
        var txtWidth = max(
          txts.map(txt => {
            return node.measureSize(txt).width
          })
        )
        var txtHeight = txts.length * node.textHeight
        var ratioX = node.width() / txtWidth
        var ratioY = node.height() / txtHeight
        var ratio = min([ratioX, ratioY])
        node.setAttrs({ fontSize: node.getAttr('fontSize') * ratio })
        var i = 0
        while (
          node.textArr.map(t => t.text).join('') !== txts.join('') &&
          i < 500 &&
          txts.length * node.textHeight <= node.height()
        ) {
          node.setAttrs({ fontSize: node.getAttr('fontSize') - 0.1 })
          node.getLayer().batchDraw()
          i++
        }
      }
    },
    textTransform(text) {
      const { layer } = this
      if(get(layer, 'textDirection') && get(layer, 'textDirection') == 'vertical'){
        let arrayText = [];
        for (var a=0; a < text.length; a++){
          arrayText = [...arrayText, text[a] + '\n'];
        }
        text = arrayText.join('').toString();
      }
      var transform = get(layer, 'textTransform')
      switch (transform) {
        case 'uppercase':
          return text.toUpperCase()
        case 'lowercase':
          return text.toLowerCase()
        default:
          return text
      }
    },
    checkOffset() {
      const { configText, artwork } = this
      if (artwork && artwork.useOffset) {
        this.offset = getTextOffset(
          configText.width,
          configText.height,
          configText.fontFamily,
          this.fontSize
        )
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Artwork/Text.vue